import {Injectable} from '@angular/core';
import {ErrorLogService} from '../modules/common/error-log.service';
import {EnvironmentType} from '../modules/common/enums/environment-type';
import {ApplicationError} from '../modules/common/model/application-error';
import {ApiRouteConfig} from '../config/api.route.config';
import {noop, Subject} from 'rxjs';
import {hash} from '../helpers/crypto';
import {Environment} from "../environment/environment";

@Injectable()
export class LoggerService {
  private readonly previouslyLoggedErrors = new Set<string>();
  public error$: Subject<any> = new Subject<any>();

  constructor(
      private errorLogService: ErrorLogService,
      private config: ApiRouteConfig,
      private readonly environment: Environment,
  ) {
    this.config = config;
  }

  public httpRequestError(status: number, method: string, urlWithParams: string, body: string, showModal: boolean = true) {
    if (this.isExcludedRoute(urlWithParams)) {
      showModal = false;
    }
    const error = new ApplicationError(`${status} | ${method} | ${urlWithParams} | ${body}`, null, new Date());
    console.error(error.message);
    this.environment.environmentName !== EnvironmentType.LOCAL ? this.errorLogService.sendError(error) : noop();
    showModal ? this.error$.next(null) : noop();
  }

  public async clientError(errorName: string, route: string, message: string, stackTrace: any[]) {
    const error = new ApplicationError(`${errorName} | ${route} | ${message}`, stackTrace, new Date());
    const errorIdentifier = await hash([errorName, route, message].join('-'));
    if (this.previouslyLoggedErrors.has(errorIdentifier)) {
      return console.debug('Error not reported - it was previously logged.', error);
    }
    this.environment.environmentName !== EnvironmentType.LOCAL ? this.errorLogService.sendError(error) : noop();
    this.previouslyLoggedErrors.add(errorIdentifier);
    console.log('Error reported', error);
  }

  private isExcludedRoute(urlWithParams: string) {
    return urlWithParams.endsWith(this.config.NOTIFICATIONS) ||
        urlWithParams.endsWith(this.config.NOTIFICATIONS_AP) ||
        urlWithParams.endsWith(this.config.NOTIFICATIONS_ISSUE) ||
        urlWithParams.endsWith(this.config.SYSTEM_STATUS);
  }
}

